import { BaseText, Button } from 'aimo-ui';
import useAddPaymentMethod from 'hooks/useAddPaymentMethod';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyledWrapper } from 'styles/ContainerStyles';
import { useUiStore } from 'stores/uiStore';

const MobilePayConfirmation: React.FC = () => {
  const { t } = useTranslation();
  const { addMobilePay, loadingAddMobilePay } = useAddPaymentMethod();

  const handleContinue = async () => {
    await addMobilePay();
  };

  return (
    <StyledWrapper mb={0}>
      <StyledWrapper mb={25}>
        <BaseText center>{t('paymentMethods.mobilePayConfirmation')}</BaseText>
      </StyledWrapper>
      <StyledWrapper mb={10}>
        <Button
          testID="mobilepay-continue-button"
          size="l"
          text={t('button.continue')}
          onPress={handleContinue}
          loading={loadingAddMobilePay}
          disabled={loadingAddMobilePay}
        />
      </StyledWrapper>
      <Button
        testID="mobilepay-cancel-button"
        size="l"
        text={t('button.cancel')}
        onPress={() => useUiStore.getState().setSheetModal('')}
        buttonType="tertiary"
      />
    </StyledWrapper>
  );
};

export default MobilePayConfirmation;
